import moment from 'moment'
import { cloneDeep } from 'lodash';
export default {
    /* 老数据转为新数据：一条数据分为一条或两条或三条数据 */
    /*
    {
        id: '',
        enable: true,//type为2时是老数据，意思10-17 21:00:00~ 11-16 21:04:59,
        //这个需要转为老数据格式10-17 21: 00: 00 ~10-17 23: 59: 59, 10-18 00:00:00~11-15 23:59:59 ,11-16 00:00:00~11.16 21:04:59
        startDate: "2020-10-17",
        endDate: "2020-11-16",
        description: "123",//描述
        intervals: [
            { "beginTime": "21:00:00", "endTime": "21:04:59" }
        ]
    }
    */
    oldTonewDate(obj) {
        if (!obj.intervals.length) {
            return [];
        }
        const clone = cloneDeep(obj);
        const startDateTime = `${obj.startDate} ${obj.intervals[0].beginTime}`;
        const endDateTime = `${obj.endDate} ${obj.intervals[0].endTime}`;
        const start = moment(startDateTime);
        const end = moment(endDateTime);
        const diffDays = moment(obj.endDate).diff(moment(obj.startDate), 'days');// 相差天数

        const startDate = start.format("YYYY-MM-DD")// 开始日期
        const startTime = start.format("HH:mm:00")// 开始时间
        const endDate = end.format("YYYY-MM-DD")// 结束日期
        const endTime = end.format("HH:mm:59")// 结束时间
        let res = [];
        if (start.isSame(end, 'days')) {//同一天
            res.push({
                startDate: startDate,
                endDate: endDate,
                intervals: [
                    { "beginTime": startTime, "endTime": endTime }
                ]
            })
        } else if (diffDays === 1) {
            //老数据分为2个时间段
            /* 开始天 */
            res.push({
                startDate: startDate,
                endDate: startDate,
                intervals: [
                    { "beginTime": startTime, "endTime": "23:59:59" }
                ]
            })
            /* 结束天 */
            res.push({
                startDate: endDate,
                endDate: endDate,
                intervals: [
                    { "beginTime": "00:00:00", "endTime": endTime }
                ]
            })
        } else {
            //老数据分为三个时间段
            /* 开始天 */
            res.push({
                startDate: startDate,
                endDate: startDate,
                intervals: [
                    { "beginTime": startTime, "endTime": "23:59:59" }
                ]
            })
            /* 中间天数 */
            const start1 = start.add(1, 'days').format("YYYY-MM-DD");
            const end1 = end.subtract(1, 'days').format("YYYY-MM-DD");
            res.push({
                startDate: start1,
                endDate: end1,
                intervals: [
                    { "beginTime": "00:00:00", "endTime": "23:59:59" }
                ]
            })
            /* 结束天 */
            res.push({
                startDate: endDate,
                endDate: endDate,
                intervals: [
                    { "beginTime": "00:00:00", "endTime": endTime }
                ]
            })
        }
        return res.map(item => {
            let obj = Object.assign({}, clone, item);
            return obj;
        })
    },
    DateToString(date, fmt) {
        // author: meizz
        let fat = fmt || 'YYYY-MM-DD';
        const o = {
            'M+': date.getMonth() + 1, // 月份
            'D+': date.getDate(), // 日
            'h+': date.getHours(), // 小时
            'm+': date.getMinutes(), // 分
            's+': date.getSeconds(), // 秒
            'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
            S: date.getMilliseconds() // 毫秒
        };
        if (/(Y+)/.test(fat)) fat = fat.replace(RegExp.$1, `${date.getFullYear()}`.substr(4 - RegExp.$1.length));
        for (const k in o)
            if (new RegExp(`(${k})`).test(fat))
                fat = fat.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length));
        return fat;
    },
    errorToStr(error) {
        let msg = [];
        if (error.response && error.response.data && error.response.data.errorList) {
            error.response.data.errorList.map((item) => {
                msg.push(item.errorMessage)
            })
        } else if (error.response && error.response.data) {
            if (typeof error.response.data === 'object') {
                msg.push(JSON.stringify(error.response.data))
            } else {
                msg.push(error.response.data);
            }
        } else {
            if (error && error.message) {
                msg.push(error.message)
            }
        }
        return msg.join('; ');
    }
}
